// extracted by mini-css-extract-plugin
export default {"blockText":"cDqUROCxGEqq232P6sJQ"};